<template>
  <div class="m-l-50 m-t-30 w-500" v-loading="fullLoading">
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="表单标识" prop="name">
        <span>form_</span>
        <el-input v-model.trim="form.name" class="h-40 w-150"></el-input>
      </el-form-item>
      <el-form-item label="表单名称" prop="title">
        <el-input v-model.trim="form.title" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="表描述">
        <el-input v-model.trim="form.des" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="普通索引">
        <div v-for="(item, index) in form.config.index" class="m-b-10">
          <el-select v-model="item.field_id" class="w-230 m-r-10" multiple>
            <el-option v-for="option in fields" :label="option.name + '(' + option.title + ')'" :value="option.field_id"></el-option>
          </el-select>
          <el-input class="w-150" v-model="item.name" placeholder="索引名称"></el-input>
          <el-button type="danger" size="small" @click="deleteIndex(index)">删除</el-button>
        </div>
        <el-button type="primary" @click="addIndex">添加普通索引</el-button>
      </el-form-item>
      <el-form-item label="唯一索引">
        <div class="m-b-10" v-show="needUnique">
          <el-select v-model="form.config.unique.field_id" class="m-r-10" :disabled="uniqueForbid">
            <el-option v-for="option in fields" :label="option.name + '(' + option.title + ')'" :value="option.field_id"></el-option>
          </el-select>
          <el-button type="danger" size="small" @click="deleteUnique" v-show="!uniqueForbid">删除</el-button>
        </div>
        <el-button type="primary" @click="addUnique" :disabled="needUnique">添加唯一索引</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="edit()" :loading="isLoading">提交</el-button>
        <el-button @click="goback()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import _verify from '../../assets/js/verify'
  export default {
    data() {
      return {
        fullLoading: false,
        isLoading: false,
        id: '',
        rules: {
          name: [
            { required: true, message: '请输入模型标识' },
            { validator: this.isContainUpperCase, trigger: 'blur' },
            { validator: this.isEngAndNum, trigger: 'blur' }
          ],
          title: [
            { required: true, message: '请输入模型名称' }
          ]
        },
        form: {
          name: '',
          title: '',
          // engine: '',
          des: '',
          index: [],
          config: {
            index: [],
            unique: {}
          }
        },
        fields: [],  // 本表单的字段
        needUnique: false,
        configModel: {
          index: [],
          unique: {
            can_delete: 1,
            field_id: null
          }
        },
        indexModel: {
          field_id: [],
          name: ''
        },
        uniqueModel: {
          can_delete: 1,
          field_id: null
        }
      }
    },
    created() {
      this.id = this.$route.query.id
      this.getDetail()
    },
    methods: {
      getDetail() {
        this.fullLoading = true
        this.apiGet(`form/models/${this.id}`).then(async (res) => {
          if (res.code == 200) {
            if (!res.data.config) {
              res.data.config = _.cloneDeep(this.configModel)
            } else {
              if (res.data.config.unique &&
                  !_g.isRealEmpty(res.data.config.unique.field_id)) {
                this.needUnique = true
              }
            }
            this.form = res.data
            if (this.form.name.substr(0, 5) == 'form_') {
              this.form.name = this.form.name.substr(5, this.form.name.length - 5)
            }
            this.fields = await this.getFields(this.form.id)
          } else {
            _g.dealError(this, res)
          }
          this.fullLoading = false
        })
      },
      addUnique() {
        this.needUnique = true
      },
      deleteUnique() {
        this.needUnique = false
        if (this.form.config) {
          this.form.config.unique = _.cloneDeep(this.uniqueModel)
        }
      },
      addIndex() {
        this.form.config.index.push(_.cloneDeep(this.indexModel))
      },
      deleteIndex(index) {
        this.form.config.index.splice(index, 1)
      },
      edit() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            let postData = JSON.parse(JSON.stringify(this.form))
            postData.name = 'form_' + postData.name
            this.apiPut(`form/models/${this.id}`, '', postData).then((res) => {
              if (res.code == 200) {
                _g.toastMsg(this, 'success', '修改成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              } else {
                this.isLoading = !this.isLoading
                _g.dealError(this, res)
              }
            })
          }
        })
      },
      isEngAndNum(rule, value, callback) {
        if (!_verify.isEngAndNum(value)) {
          callback(new Error('请输入数字或英文'))
        } else {
          callback()
        }
      },
      isContainUpperCase(rule, value, callback) {
        if (!_verify.isContainUpperCase(value)) {
          callback(new Error('表单标识不能输入大写字母'))
        } else {
          callback()
        }
      },
      async getFields(id) {
        this.fullLoading = true
        let postData = {
          params: {
            type: 1
          }
        }
        let res = await this.apiGet(`form/models/${id}/fields`, postData)
        let data = this.promiseHandler(data, res)
        this.fullLoading = false
        return data
      },
      goback() {
        router.go(-1)
      }
    },
    computed: {
      uniqueForbid() {
        return this.form.config.unique.can_delete == 0
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// edit.vue?55a028c9